import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import axios from 'axios';
import { 
  Box, Typography, Paper, Alert, FormControlLabel, Switch, CircularProgress
} from '@mui/material';

const StatusNotifications = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [notifUpdating, setNotifUpdating] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState(false);

  useEffect(() => {
    const loadProfileData = async () => {
      setLoading(true);
      try {
        const profileRes = await axios.get('/api/users/profile');
        setFormData(profileRes.data);
      } catch (err) {
        setError('Impossibile caricare i dati.');
      } finally {
        setLoading(false);
      }
    };
    loadProfileData();
  }, []);

  if (loading || !formData) return <CircularProgress />;

  return (
    <Paper sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>Stato e Notifiche</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Lo stato indica se sei attualmente disponibile per nuove opportunità. Le notifiche email servono per ricevere nuovi annunci compatibili.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.availabilityStatus === 'attivo'}
              onChange={async (e) => {
                setStatusUpdating(true);
                setError('');
                setSuccess('');
                try {
                  const desired = e.target.checked ? 'attivo' : 'non_disponibile';
                  await axios.put('/api/users/profile', { availabilityStatus: desired });
                  setFormData(prev => ({ ...prev, availabilityStatus: desired }));
                  setSuccess('Stato aggiornato con successo!');
                } catch (err) {
                  setError(err.response?.data?.error || 'Errore durante l\'aggiornamento dello stato.');
                } finally {
                  setStatusUpdating(false);
                }
              }}
              disabled={statusUpdating}
            />
          }
          label={formData.availabilityStatus === 'attivo' ? 'Stato: Attivo' : 'Stato: Non Disponibile'}
        />
      </Box>

      <Box>
        <FormControlLabel
          control={
            <Switch
              checked={!!formData.emailNotifications}
              onChange={async (e) => {
                setNotifUpdating(true);
                setError('');
                setSuccess('');
                try {
                  const desired = e.target.checked;
                  await axios.put('/api/users/email-notifications', { emailNotifications: desired });
                  setFormData(prev => ({ ...prev, emailNotifications: desired }));
                  setSuccess('Preferenze email aggiornate!');
                } catch (err) {
                  setError(err.response?.data?.error || 'Errore durante l\'aggiornamento delle notifiche.');
                } finally {
                  setNotifUpdating(false);
                }
              }}
              disabled={notifUpdating}
            />
          }
          label="Ricevi email sulle nuove opportunità"
        />
      </Box>

      {error && <Alert severity="error" sx={{ mt: 3 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mt: 3 }}>{success}</Alert>}
    </Paper>
  );
};

export default StatusNotifications;
